let VIEW_NAME = {
  loading: 'Loading',
  ready: 'Ready',
  error: 'Error',
}

export function getView(value) {
  return VIEW_NAME[value] ?? 'Loading'
}
